import { sendPayload } from 'pages/ProjectsPage/helpers/ProjectsPageHelper';
import React, { useState } from 'react';
import Card from 'shared/Card';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';
import { sendPackagePayload } from '../helper/packagePageHelper';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { projectsPlaceholders } from 'shared/utils/projectsPlaceholders';

type PackageCardProps = {
  chart: any;
  packageUuid: string;
};

export default function PackageCard(props: PackageCardProps) {
  const { chart } = props;

  const { team } = useSelector((state: RootState) => state.profile);

  const [loadingEmbedStatus, setLoadingEmbedStatus] = useState({
    loading: false,
    done: false
  });

  const [loadingLinkStatus, setLoadingLinkStatus] = useState({
    loading: false,
    done: false
  });

  const useChart = (useLink?: boolean) => {
    console.log(chart);
    sendPackagePayload(props.chart, team, useLink);
    // sendPayload(props.chart, useLink);
  };

  const onClickEmbedBtn = async () => {
    setLoadingEmbedStatus((prev) => ({ ...prev, loading: true }));

    useChart();

    setTimeout(() => setLoadingEmbedStatus(() => ({ loading: false, done: true })), 500);
    setTimeout(() => setLoadingEmbedStatus(() => ({ loading: false, done: false })), 1000);
  };

  const onClickLinkBtn = async () => {
    setLoadingLinkStatus((prev) => ({ ...prev, loading: true }));

    useChart(true);

    setTimeout(() => setLoadingLinkStatus(() => ({ loading: false, done: true })), 500);
    setTimeout(() => setLoadingLinkStatus(() => ({ loading: false, done: false })), 1000);
  };

  return (
    <Card
      title={chart.name}
      href={({ ...ps }) => (
        <a {...ps} href={undefined}>
          {ps.children}
        </a>
      )}
      thumbnail={chart.thumbnail_url}
      hideHoverDescriptor={false}
      highlighted={false}
      placeholder={projectsPlaceholders[1]}
      children={
        <div className="flex gap-1">
          <PrimaryButton
            className="w-[40px]"
            tooltip={'Public link'}
            useLoader={{
              default: {
                text: '',
                icon: 'link'
              },
              loading: {
                text: '',
                check: loadingLinkStatus.loading
              },
              done: {
                text: '',
                icon: 'circle-check',
                check: loadingLinkStatus.done
              }
            }}
            text={''}
            onClick={onClickLinkBtn}
            buttonType={ButtonType.Circle}
            buttonColor={ButtonColor.NavyBlue}
          />

          <PrimaryButton
            className="w-[40px]"
            tooltip={'Embed code'}
            useLoader={{
              default: {
                text: '',
                icon: 'code'
              },
              loading: {
                text: '',
                check: loadingEmbedStatus.loading
              },
              done: {
                text: '',
                icon: 'circle-check',
                check: loadingEmbedStatus.done
              }
            }}
            text={''}
            onClick={onClickEmbedBtn}
            buttonType={ButtonType.Circle}
            buttonColor={ButtonColor.NavyBlue}
            loaderClass={'bg-red'}
          />
        </div>
      }
    />
  );
}
